exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n#app[data-v-7ba5bd90]{min-height:100%\n}\n@media (max-width: 1023px){\n.d-flex[data-v-7ba5bd90]{display:block !important\n}\n}\n@media (max-width: 1024px){\n.nav[data-v-7ba5bd90]{position:fixed\n}\n}\n", "", {"version":3,"sources":["/Users/danielngo/Desktop/fastpro/frontend/src/App.vue"],"names":[],"mappings":";AAAA,sBAAK,eAAe;CAAC;AAAA;AAA2B,yBAAQ,wBAAwB;CAAE;CAAA;AAAA;AAA2B,sBAAK,cAAc;CAAE;CAAA","file":"App.vue","sourcesContent":["#app{min-height:100%}@media (max-width: 1023px){.d-flex{display:block !important}}@media (max-width: 1024px){.nav{position:fixed}}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-7ba5bd90","scoped":true,"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = l+kv
// module chunks = 4